import SendInform from "@/business/send/SendInform";
import SendNotify from "@/business/send/SendNotify";
import SendSchedule from "@/business/send/SendSchedule";
import { LayoutHeader } from "@/Header";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useState } from "react";
import useHideNav from "^/common/useHideNav";

export const Route = createFileRoute("/business/layout/notify-send")({
  component: RouteComponent,
});

function RouteComponent() {
  // const {
  //   handleSubmit,
  //   control,
  //   formState: { isValid },
  //   watch,
  // } = useForm<InformSendState>({
  //   defaultValues: {
  //     recipient: "",
  //     animal: "",
  //     content: "",
  //   },
  //   mode: "onBlur",
  // });
  useHideNav(); // 저장/발송 버튼을 하단 고정으로 쓰므로 nav 를 숨긴다
  const { history } = useRouter();

  const [selected, setSelected] = useState(0);

  // const ownerOptions = [
  //   { value: "owner1", label: "위탁사업자 이름" },
  //   { value: "owner2", label: "위탁사업자 이름2" },
  // ];
  // console.log(watch());
  // const bindSubmit = (data: InformSendState) => {
  //   console.log(data);
  //   alert("발송");
  //   // history.push("/business/layout/to-school");
  // };
  return (
    <>
      <LayoutHeader title={"알림장"} hasBackBtn hasFootPrint={false} />
      {/* 수신자 */}
      {/* 하단 nav 를 숨기고 저장/발송 버튼을 화면 하단에 고정한다(예약하기 화면과 동일 구성).
          pb-24 는 고정 버튼 바에 마지막 입력이 가리지 않도록 확보하는 여백(예약하기와 동일 값). */}
      <div className="flex flex-col flex-1 min-h-0 overflow-y-auto pb-24">
        <div className="flex gap-2 bg-[#F5F5F5] px-5 py-5 justify-center">
          {["알림장", "일정 공지", "공지사항"].map((label, idx) => (
            <button
              key={label}
              className={`px-5 py-1.5 rounded-full border font-medium text-[#666666] w-full
                ${
                  selected === idx
                    ? "border-orange-400 text-orange-500"
                    : "border-gray-300 text-gray-500"
                }
                bg-white`}
              style={selected === idx ? { borderWidth: 1 } : {}}
              onClick={() => setSelected(idx)}
            >
              {label}
            </button>
          ))}
        </div>
        {selected === 0 && (
          <div className="px-5 pb-1 flex justify-end">
            <button
              type="button"
              className="text-[12px] text-[#FF9934] font-medium"
              onClick={() => history.push("/business/layout/notify-batch")}
            >
              ✨ 오늘 등원 펫 일괄 작성 →
            </button>
          </div>
        )}
        {selected === 0 && <SendInform />}
        {selected === 1 && <SendSchedule />}
        {selected === 2 && <SendNotify />}
      </div>
    </>
  );
}
